var exports = {
  "ND": "ProfileCardBanner.module__headerSection___RlVDR0",
  "cy": "ProfileCardBanner.module__bannerWrapper___RlVDR0",
  "vK": "ProfileCardBanner.module__banner___RlVDR0",
  "KI": "ProfileCardBanner.module__avatarButton___RlVDR0",
};

module.exports = exports;
